import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import FormatAndDisplay from "../FormatAndDisplay/FormatAndDisplay";
import styles from "./ShowDadosCard.module.css";

interface Props {
  title: string;
  descriptions: Record<string, string>;
  data: Record<string, any>;
  editMode?: boolean;
  onChange?: (key: string, value: any) => void;
}

const ShowDadosCard: React.FC<Props> = ({
  title,
  descriptions,
  data,
  editMode,
  onChange, // Adicionado
}) => {
  const handleChange =
    (key: string) => (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(key, event.target.value);
      }
    };

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.cardBody}>
      {Object.entries(data).map(
        ([key, value]) =>
          value && (
            <div key={key} className={styles.title}>
              {editMode ? (
                <div>
                  <span>{descriptions[key]}</span>
                  <TextField
                  fullWidth
                  variant="standard"
                  defaultValue={value}
                  label={descriptions[key] || key}
                  className={styles.input}
                  onChange={handleChange(key)} // Adicionado
                />
                </div>
              ) : (
                <FormatAndDisplay
                  label={descriptions[key] || key}
                  value={value}
                />
              )}
            </div>
          ),
      )}
      </div>
    </div>
  );
};

export default ShowDadosCard;
